export default [
    {
        name: "Sofia",
        company: "CEO Comany 1",
        comment: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    },
    {
        name: "Mike",
        company: "CEO Company 2",
        comment: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    },
    {
        name: "Sandra",
        company: "CEO Company 3",
        comment: "Dolor magna eget est lorem ipsum. Tellus id interdum velit laoreet id donec ultrices. Etiam sit amet nisl purus in mollis. Ultrices vitae auctor eu augue. Donec adipiscing tristique risus nec feugiat in fermentum. Turpis tincidunt id aliquet risus feugiat in ante metus dictum.",
    },
    {
        name: "Laura",
        company: "CEO Company 4",
        comment: "Turpis egestas maecenas pharetra convallis posuere morbi leo urna. Dolor sed viverra ipsum nunc aliquet bibendum.",
    },
    {
        name: "Patricia",
        company: "CEO Company 5",
        comment: "Ultrices sagittis orci a scelerisque purus semper eget duis. Luctus venenatis lectus magna fringilla urna porttitor rhoncus dolor",
    },
]